
/**
 * 강의 상세 설명 번역 정보
 */
export type CourseDetailTranslationsItem = {
  /**
   * 해당 언어의 상세 설명 번역
   * @nullable
   */
  description?: string | null;
  /** 언어 코드 (예: ko, en) */
  language: string;
  /**
   * 해당 언어의 제목 번역
   * @nullable
   */
  title?: string | null;
};
